module.exports = "/assets/afdb9a206473af851a6101d304e69c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MU.png
// module id = 1627
// module chunks = 0